function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.44,39.12h-.9A11.67,11.67,0,0,1,5.67,39,5.86,5.86,0,0,1,4,38.4a4.93,4.93,0,0,1-1.39-1,5.12,5.12,0,0,1-1-1.4,5.69,5.69,0,0,1-.55-1.66A11.7,11.7,0,0,1,.9,32.47V7.55a11.7,11.7,0,0,1,.16-1.87A5.6,5.6,0,0,1,1.6,4a5.12,5.12,0,0,1,1-1.4A5.58,5.58,0,0,1,4,1.6a5.69,5.69,0,0,1,1.66-.55A11.83,11.83,0,0,1,7.54.89H132.08a11.58,11.58,0,0,1,1.86.16,5.85,5.85,0,0,1,1.67.55,5.34,5.34,0,0,1,1.4,1,5.68,5.68,0,0,1,1.52,3.05,11.85,11.85,0,0,1,.18,1.88V32.47a12.72,12.72,0,0,1-.17,1.85A5.89,5.89,0,0,1,138,36a5.71,5.71,0,0,1-1,1.39,5.12,5.12,0,0,1-1.4,1,5.75,5.75,0,0,1-1.67.55,11.7,11.7,0,0,1-1.87.16H8.44Z",
  transform: "translate(-0.02)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140.62px",
    height: "41px",
    viewBox: "0 0 140.62 41"
  }, props), React.createElement("path", {
    d: "M130.09,0H7.52a13.39,13.39,0,0,0-2,.18,6.74,6.74,0,0,0-1.9.63A6.11,6.11,0,0,0,2,2,6.07,6.07,0,0,0,.82,3.62a6.74,6.74,0,0,0-.63,1.9,12.18,12.18,0,0,0-.17,2v25a12.18,12.18,0,0,0,.17,2,6.8,6.8,0,0,0,.63,1.91A6,6,0,0,0,2,38a6.07,6.07,0,0,0,1.62,1.18,6.74,6.74,0,0,0,1.9.63,13.39,13.39,0,0,0,2,.18H132.1a13.39,13.39,0,0,0,2-.18,7.14,7.14,0,0,0,1.91-.63A6,6,0,0,0,137.62,38a6.28,6.28,0,0,0,1.19-1.61,6.76,6.76,0,0,0,.61-1.91,12.2,12.2,0,0,0,.19-2v-25a12.2,12.2,0,0,0-.19-2,6.7,6.7,0,0,0-.61-1.9A6.33,6.33,0,0,0,137.62,2,6.07,6.07,0,0,0,136,.82a7.07,7.07,0,0,0-1.9-.63,13.39,13.39,0,0,0-2-.18h-2Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#a6a6a6"
    }
  }), _ref, React.createElement("path", {
    d: "M42.12,14.75H38.41V8.8h.92v5.1h2.79Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M43.21,8.93a.55.55,0,0,1,.55-.55h0a.55.55,0,1,1,.15,1.09h-.15a.56.56,0,0,1-.57-.53Zm.13,1.33h.88v4.49h-.88Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M47.3,10.17c1,0,1.67.47,1.76,1.26h-.85c-.08-.33-.4-.54-.91-.54s-.87.24-.87.59.23.44.72.55l.74.17c.86.2,1.26.57,1.26,1.23,0,.84-.79,1.41-1.86,1.41s-1.77-.48-1.85-1.28h.89c.11.35.44.56,1,.56s.94-.25.94-.61-.21-.44-.66-.54l-.78-.19c-.86-.2-1.25-.58-1.25-1.25A1.59,1.59,0,0,1,47.3,10.17Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M51.52,9.14v1.14h1V11h-1v2.31c0,.47.19.67.63.67h.34v.74a1.93,1.93,0,0,1-.48,0c-1,0-1.38-.35-1.38-1.22V11h-.71v-.75h.71V9.14Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M57.42,13.54a1.82,1.82,0,0,1-2,1.3,2,2,0,0,1-2.09-1.9,2,2,0,0,1,0-.42,2.07,2.07,0,0,1,1.77-2.33l.3,0c1.25,0,2,.86,2,2.27v.31H54.3v.05a1.19,1.19,0,0,0,1.1,1.28h.1a1.09,1.09,0,0,0,1.07-.54ZM54.3,12.09h2.27a1.09,1.09,0,0,0-1-1.16h-.11a1.14,1.14,0,0,0-1.16,1.14Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M58.67,10.26h.86V11h.06a1.36,1.36,0,0,1,1.35-.8,1.46,1.46,0,0,1,1.56,1.35,1.15,1.15,0,0,1,0,.32v2.91H61.6V12.07c0-.73-.31-1.09-1-1.09a1,1,0,0,0-1.08.92,1.62,1.62,0,0,0,0,.22v2.63h-.89Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M66.09,12.5a2.13,2.13,0,1,1,4.24-.41,2.8,2.8,0,0,1,0,.41,2.13,2.13,0,1,1-4.24.41A2.8,2.8,0,0,1,66.09,12.5Zm3.33,0c0-1-.44-1.54-1.21-1.54S67,11.53,67,12.5s.43,1.55,1.2,1.55S69.42,13.48,69.42,12.5Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M71.53,10.26h.86V11h.06a1.36,1.36,0,0,1,1.34-.8,1.46,1.46,0,0,1,1.57,1.34,1.22,1.22,0,0,1,0,.33v2.91h-.89V12.07c0-.73-.31-1.09-1-1.09a1,1,0,0,0-1.08.92,1.62,1.62,0,0,0,0,.22v2.63H71.5Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("circle", {
    cx: 20.12,
    cy: 19.98,
    r: 12.58,
    style: {
      "fill": "red"
    }
  }), React.createElement("path", {
    d: "M20.13,14a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-.57A6.57,6.57,0,1,0,26.71,20a6.57,6.57,0,0,0-6.58-6.57Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("polygon", {
    points: "17.83 23.27 23.4 19.84 17.83 16.69 17.83 23.27",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M43.58,20.82H46l-2.84,6v3.66h-2.2V26.86l-2.85-6h2.38L42,24.41Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M49,22.54a3.34,3.34,0,0,1,2.65,1.07,4.36,4.36,0,0,1,.94,3,4.31,4.31,0,0,1-1,3,3.78,3.78,0,0,1-5.3,0,4.44,4.44,0,0,1-.94-3,4.24,4.24,0,0,1,1-2.95A3.38,3.38,0,0,1,49,22.54Zm0,1.93c-1,0-1.46.74-1.46,2.21S48,28.74,49,28.74s1.45-.68,1.45-2S49.93,24.47,49,24.47Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M53.77,22.68h2.12v4.55a1.91,1.91,0,0,0,.27,1.14,1.28,1.28,0,0,0,1.76,0,1.91,1.91,0,0,0,.27-1.14V22.68h2.12v4.55a3.62,3.62,0,0,1-.83,2.56,3.82,3.82,0,0,1-4.88,0,3.62,3.62,0,0,1-.83-2.56Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M65.8,22.76v7.76H63.6V22.76H61.19V20.82h7.29l-.55,1.94Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M68.42,22.68h2.11v4.55a1.84,1.84,0,0,0,.28,1.14,1.06,1.06,0,0,0,.88.35,1,1,0,0,0,.87-.35,1.84,1.84,0,0,0,.28-1.14V22.68H75v4.55a3.57,3.57,0,0,1-.83,2.56,3.81,3.81,0,0,1-4.87,0,3.57,3.57,0,0,1-.83-2.56Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M78.53,19.8v3.46a2.61,2.61,0,0,1,1.86-.72,2.9,2.9,0,0,1,2.38,1.06,4.57,4.57,0,0,1,.85,2.94,4.61,4.61,0,0,1-.89,3,3.07,3.07,0,0,1-2.51,1.09,2.71,2.71,0,0,1-1.85-.76v.61H76.44V19.8ZM80,24.47c-1,0-1.5.72-1.5,2.17a2.9,2.9,0,0,0,.35,1.6,1.29,1.29,0,0,0,1.12.5,1.27,1.27,0,0,0,1.13-.49,2.84,2.84,0,0,0,.35-1.61A3,3,0,0,0,81.13,25,1.22,1.22,0,0,0,80,24.47Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M91.15,27.48H86.71a1.54,1.54,0,0,0,1.67,1.3,2.24,2.24,0,0,0,.86-.15,3.65,3.65,0,0,0,.89-.57l1.07,1.43a4.47,4.47,0,0,1-1.37.91,4.27,4.27,0,0,1-1.59.27,3.51,3.51,0,0,1-2.7-1.07,4.1,4.1,0,0,1-1-2.9,4.57,4.57,0,0,1,1-3A3.11,3.11,0,0,1,88,22.54,2.9,2.9,0,0,1,90.7,24a4.81,4.81,0,0,1,.55,2.45A10.13,10.13,0,0,1,91.15,27.48Zm-4.47-1.66h2.51a1.67,1.67,0,0,0-.34-1,1,1,0,0,0-.85-.37C87.32,24.42,86.88,24.89,86.68,25.82Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M95.81,30.52v-9.7h2.11l2.83,5.93,2.8-5.93h2.12v9.7h-2.18V25.6l-2.07,4.61h-1.36L98,25.6v4.92Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M107.22,22.68h2.12v4.55a1.84,1.84,0,0,0,.28,1.14,1.27,1.27,0,0,0,1.75,0,1.91,1.91,0,0,0,.28-1.14V22.68h2.11v4.55a3.57,3.57,0,0,1-.83,2.56,3.82,3.82,0,0,1-4.88,0,3.62,3.62,0,0,1-.83-2.56Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M114.77,29.66l.75-1.68a4.26,4.26,0,0,0,1,.64,2.93,2.93,0,0,0,1,.16c.67,0,1-.19,1-.58a.5.5,0,0,0-.25-.4,4,4,0,0,0-.9-.4,5.78,5.78,0,0,1-1.55-.73,2,2,0,0,1-.83-1.71,2.19,2.19,0,0,1,.78-1.76,3.15,3.15,0,0,1,2.09-.66,4.05,4.05,0,0,1,2.52.79L119.72,25a3,3,0,0,0-1.74-.58c-.52,0-.78.17-.78.5a.38.38,0,0,0,.2.34,4.25,4.25,0,0,0,.83.34,4.73,4.73,0,0,1,2,1,2.12,2.12,0,0,1,.58,1.53,2.23,2.23,0,0,1-.83,1.83,3.51,3.51,0,0,1-2.25.67A4.31,4.31,0,0,1,114.77,29.66Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M123,19.42a1.23,1.23,0,0,1,1.23,1.23,1.26,1.26,0,0,1-2.12.89,1.19,1.19,0,0,1-.35-.88A1.23,1.23,0,0,1,123,19.42Zm1.84,11.17h-.61a2.32,2.32,0,0,1-1.75-.57,2.61,2.61,0,0,1-.54-1.85V22.68h2.11V28a1.45,1.45,0,0,0,.07.44.26.26,0,0,0,.25.11h.47Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M132.19,23.61l-1,1.55a3.27,3.27,0,0,0-1.82-.69,1.39,1.39,0,0,0-1.18.57,2.58,2.58,0,0,0-.44,1.58,2.49,2.49,0,0,0,.44,1.57,1.49,1.49,0,0,0,1.24.55,2.66,2.66,0,0,0,.93-.16,4.3,4.3,0,0,0,1-.58l1,1.55a4.79,4.79,0,0,1-1.4.87,4.67,4.67,0,0,1-1.6.25,3.48,3.48,0,0,1-2.7-1.07,4.18,4.18,0,0,1-1-3,4.32,4.32,0,0,1,1-3,3.44,3.44,0,0,1,2.69-1.11,4.21,4.21,0,0,1,1.5.24A4.87,4.87,0,0,1,132.19,23.61Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }));
};

export default __webpack_public_path__ + "static/media/listen-youtube.61f93cc8.svg";
export { SvgComponent as ReactComponent };